<template lang="html">
  <div class="clients">
    <label class="labelTitle blue">{{titleToUpperCase($t('awards.clients.title'))}}</label>
    <p class="description" v-html="$t('awards.clients.description')"></p>
    <div class="list">
      <img v-for="(item,key) in $t('awards.clients.clients')" :key="key" :src="item">
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
